export type Uuid = `${string}-${string}-${string}-${string}-${string}` & { __uuidBrand: void };
